import { defineComponent } from 'vue';
export default defineComponent({
    name: 'ATableColumn',
    slots: ['title', 'filterIcon'],
    render() {
        return null;
    },
});
